import Vue from 'vue';
import VueRouter from 'vue-router';

// ========== 核心修复：解决路由重定向Promise报错（必须写在Vue.use之前、创建实例之前） ==========
const originPush = VueRouter.prototype.push;
const originReplace = VueRouter.prototype.replace;

// 重写push方法
VueRouter.prototype.push = function(location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject);
  } else {
    originPush.call(this, location, () => {}, () => {});
  }
}

// 重写replace方法
VueRouter.prototype.replace = function(location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject);
  } else {
    originReplace.call(this, location, () => {}, () => {});
  }
}

Vue.use(VueRouter)

/**
 * isLogin 登录状态 false不需要登录就能访问    true需要登录才能访问
 * 
 * linkActiveClass  router-link 导航栏激活class名
 * 
**/

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('../page/home/index.vue'),
		meta: {
			title: '首页',//对应导航栏高亮
			name:'国联易拍：数智盘活资产，一站式拍卖服务平台',//对应页面网站标题
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/corpore',
		name: 'corpore',
		component: () => import('../page/corpore/index.vue'),
		meta: {
			title: '标的大厅',
			name:'标的大厅_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/corporeDetail',
		name: 'corporeDetail',
		component: () => import('../page/corporeDetail/index.vue'),
		meta: {
			title: '标的详情',
			name:'拍卖大厅_国联易拍',
			isLogin: false,
		}
	},
	{
		path: '/auction',
		name: 'auction',
		component: () => import('../page/auction/index.vue'),
		meta: {
			title: '拍卖会',
			name:'拍卖会_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/auctionDetail',
		name: 'auctionDetail',
		component: () => import('../page/auctionDetail/index.vue'),
		meta: {
			title: '拍卖会详情',
			name:'拍卖会详情_国联易拍',
			isLogin: false,
		}
	},
	{
		path: '/notice',
		name: 'notice',
		component: () => import('../page/notice/index.vue'),
		meta: {
			title: '拍卖公告',
			name:'拍卖公告_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/pricing',
		name: 'pricing',
		component: () => import('../page/pricing/index.vue'),
		meta: {
			title: '金属行情',
			name:'金属行情_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/enterprise',
		name: 'enterprise',
		component: () => import('../page/enterprise/index.vue'),
		meta: {
			title: '企业专场',
			name:'企业专场_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/contactMe',
		name: 'contactMe',
		component: () => import('../page/contactMe/index.vue'),
		meta: {
			title: '联系我们',
			name:'联系我们_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../page/login/index.vue'),
		meta: {
			title: '登录',
			name:'登录_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('../page/register/index.vue'),
		meta: {
			title: '个人注册',
			name:'个人注册_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/password',
		name: 'password',
		component: () => import('../page/password/index.vue'),
		meta: {
			title: '忘记密码',
			name:'忘记密码_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/companyregister',
		name: 'companyregister',
		component: () => import('../page/companyregister/index.vue'),
		meta: {
			title: '企业注册',
			name:'企业注册_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/helpCenter',
		name: 'helpCenter',
		component: () => import('../page/helpCenter/index.vue'),
		meta: {
			title: '帮助中心',
			name:'帮助中心_国联易拍',
			isLogin: false,
			scrollTop: true //标记这个页面进入需要滚到顶部
		}
	},
	{
		path: '/ceshi',
		name: 'ceshi',
		component: () => import('../page/ceshi/index.vue'),
		meta: {
			title: '测试',
			isLogin: false,
		}
	},
	{
		path: '/user',
		name: 'user',
		component: () => import('../page/my/index.vue'),
		meta: {
			title: '个人中心',
			name:'个人中心_国联易拍',
			isLogin: true,
			
		},
		redirect: '/user/account',
		children:[
			{
			    path: '/user/account',//账户信息
			    name: 'useraccount',
			    component: () => import('../page/my/common/account.vue'),
			    meta: {
			        title: '账户信息',
					name:'个人中心_国联易拍',
			        isLogin: true,
			    },
			},
			{
			    path: '/user/auction',//我的竞拍
			    name: 'userauction',
			    component: () => import('../page/my/common/auction.vue'),
			    meta: {
			        title: '我的竞拍',
					name:'个人中心_国联易拍',
			        isLogin: true,
			    },
			},
			{
			    path: '/user/attention',//我的竞拍
			    name: 'userattention',
			    component: () => import('../page/my/common/attention.vue'),
			    meta: {
			        title: '我的关注',
					name:'个人中心_国联易拍',
			        isLogin: true,
			    },
			},
			{
			    path: '/user/footprint',//我的竞拍
			    name: 'userfootprint',
			    component: () => import('../page/my/common/footprint.vue'),
			    meta: {
			        title: '我的足迹',
					name:'个人中心_国联易拍',
			        isLogin: true,
			    },
			},
			{
			    path: '/user/logout',//我的竞拍
			    name: 'userlogout',
			    component: () => import('../page/my/common/logout.vue'),
			    meta: {
			        title: '注销账号',
					name:'个人中心_国联易拍',
			        isLogin: true,
			    },
			},
		]
	},
	{
		path: '*',
		name: '404',
		component: () => import('../page/404.vue'),
		meta: {
			title: '404',
			isLogin: false,
		}
	}
]

const router = new VueRouter({
	linkActiveClass: 'selected',
	routes,
	// mode: 'hash',
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		// 如果目标路由meta标记scrollTop:true，才滚到顶部；其余页面保持原地
		if(to.meta.scrollTop){
			return { x:0, y:0 }
		}
		return null;
	}
	// 跳转新路由  页面滚动到顶部
	// scrollBehavior(to, from, savedPosition) {
	// 	if (savedPosition) {
	// 		return savedPosition;
	// 	} else {
	// 		return {
	// 			x: 0,
	// 			y: 0
	// 		};
	// 	}
	// }
})

export default router
